// src/components/UserFiles/UserFileSignatureChip.jsx

import React from 'react';
import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const UserFileSignatureChip = ({ t, signaturesCount = 0, signedByMe }) => {
  const hasAnySignatures = signaturesCount > 0;
  if (!hasAnySignatures) return null;

  const count = signaturesCount;
  const me = !!signedByMe;

  let label = t('files.signed', 'Podpísané');

  if (me && count > 1) {
    label = t(
      'files.signed_by_me_and_others',
      'Podpísané vami a ďalšími ({{count}})',
      { count }
    );
  } else if (me) {
    label = t('files.signed_by_me', 'Podpísané vami');
  } else if (count > 0) {
    label = t(
      'files.signed_count',
      'Podpísané ({{count}}×)',
      { count }
    );
  }

  return (
    <Chip
      icon={<CheckCircleIcon sx={{ fontSize: '1rem !important' }} />}
      label={label}
      color="success"
      size="small"
      variant="outlined"
      sx={{ 
        mr: { xs: 0, sm: 2 },
        borderRadius: '6px',
        fontWeight: 600,
        bgcolor: 'success.50',
        borderColor: 'success.200',
        color: 'success.800',
        '& .MuiChip-label': {
            px: 1
        }
      }}
    />
  );
};

export default UserFileSignatureChip;